import { ResultStatus } from '@dispatch/shared/types';
import { ReactNode } from 'react';
import { DarkBox } from '../dark-box';
import { TopNavBarProps } from '../top-nav-bar/TopNavBar';
import { AppLayoutRenderHelper, rendersPage } from './AppLayoutRenderHelper';

export interface AppLayoutProps extends TopNavBarProps {
  children?: ReactNode;
  status?: ResultStatus;
  /** Re-invokes the bootstrap queries when the error state is shown. */
  onRetry?: () => void;
}

// A page can be taller than the screen, so the navy background grows with it.
// Loading, BootstrapError and InvalidPermissions centre themselves with
// height 100%, which needs a fixed height to resolve against.
const GROWS_WITH_PAGE = { minHeight: '100vh' } as const;
const ONE_SCREEN = { height: '100vh' } as const;

export function AppLayout(props: AppLayoutProps) {
  return (
    <div>
      <DarkBox
        data-testid="app-layout"
        sx={rendersPage(props) ? GROWS_WITH_PAGE : ONE_SCREEN}
      >
        <AppLayoutRenderHelper {...props} />
      </DarkBox>
    </div>
  );
}

export default AppLayout;
